import { useState, createContext } from 'react';
import { jsx } from 'react/jsx-runtime';

var TooltipContext = /*#__PURE__*/createContext(undefined);
/**
 * Prevent multiple tooltips from being open at the same time
 * for example by focusing one tooltip trigger and hovering over another
 */
function TooltipProvider(props) {
  var children = props.children;
  var _useState = useState(''),
    activeTooltipId = _useState[0],
    setActiveTooltipId = _useState[1];
  var showTooltip = function showTooltip(tooltipId) {
    return setActiveTooltipId(tooltipId);
  };
  var hideTooltip = function hideTooltip() {
    return setActiveTooltipId('');
  };
  var value = {
    activeTooltipId: activeTooltipId,
    showTooltip: showTooltip,
    hideTooltip: hideTooltip
  };
  return /*#__PURE__*/jsx(TooltipContext.Provider, {
    value: value,
    children: children
  });
}

export { TooltipContext, TooltipProvider };
